// @flow
import * as React from 'react';

import { selectCartUUID } from '@gandi/cart';
import { useTranslator } from '@gandi/translate';

import { useAppSelector } from 'src/hooks';

import { selectGostackURL } from '../../modules/config';
import type { NavigationItems, NavigationTree } from '../types/layout';

export function useNavigationTree(): NavigationTree {
  const { __ } = useTranslator();
  const cartID = useAppSelector(selectCartUUID);
  const gostackUrl = useAppSelector(selectGostackURL);

  return React.useMemo(() => {
    const cartSubPath = cartID ? `/${cartID}` : '';
    const navigationTree: NavigationTree = {
      [__('Domains')]: ([
        { title: __('Buy domains'), to: `/domain/suggest${cartSubPath}` },
        { title: __('Renew domains'), to: `/domain/renew${cartSubPath}` },
        { title: __('Transfer domains'), to: `/domain/transfer${cartSubPath}` },
      ]: NavigationItems),
      [__('Hosting')]: [
        {
          title: __('Buy web hosting'),
          to: `/simplehosting/create${cartSubPath}`,
        },
        {
          title: __('Buy Wordpress hosting'),
          to: `/simplehosting/create${cartSubPath}?type=wordpress`,
        },
        {
          title: __(
            '<for-translators-use>Menu item for cloud create page' +
              '</for-translators-use>Buy cloud servers',
          ),
          href: gostackUrl,
        },
      ],
      [__('SSL Certificates')]: [
        {
          title: __('Buy SSL certificate'),
          to: `/certificate/create${cartSubPath}`,
        },
      ],
      [__('Trademark Clearinghouse')]: [
        {
          title: __('Register your trademark'),
          to: '/tmch',
        },
      ],
    };

    return navigationTree;
  }, [__, cartID, gostackUrl]);
}
